module.exports = __webpack_public_path__ + "static/img/invert.1e5d6d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/misc/invert.png
// module id = jIEk
// module chunks = 1